import InputText from "./index";

export const TimePicker = (props) => {
  return <InputText id="time" type="time" {...props} />;
};
